import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { promoCodesService } from '@/services/promoCodesService';
import type { CreatePromoCodeInput } from '@/types/promoCode.types';

export function usePromoCodes() {
  return useQuery({
    queryKey: ['admin', 'promo-codes'],
    queryFn: promoCodesService.getPromoCodes,
    staleTime: 1000 * 60, // 1 minute
  });
}

export function usePromoCode(id: string) {
  return useQuery({
    queryKey: ['admin', 'promo-codes', id],
    queryFn: () => promoCodesService.getPromoCode(id),
    enabled: !!id,
    staleTime: 1000 * 30, // 30 seconds
  });
}

export function useCreatePromoCode() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: CreatePromoCodeInput) => promoCodesService.createPromoCode(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'promo-codes'] });
    },
  });
}

export function useDeactivatePromoCode() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => promoCodesService.deactivatePromoCode(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'promo-codes'] });
    },
  });
}
